// A status change keeps its date, and every step goes on the order's history
// (statusHistory): the website shows each step with its own date to the
// customer (order page, Updates). Orders from before this start their history
// from the day they were placed.
export const statusChange = (order, step) => {
    const now = new Date();
    const current = Number(order?.status?.status ?? 0);
    const history = Array.isArray(order?.statusHistory) && order.statusHistory.length
        ? order.statusHistory
        : [{ status: 0, at: order?.Date || order?.status?.Date || now }];
    return {
        status: { status: step, Date: now },
        statusHistory: step === current && history.length ? history : [...history, { status: step, at: now }],
    };
};
